import {
  extend as veeExtend,
  configure as veeConfigure,
} from 'vee-validate';
import * as veeRules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import isNot from './rules/common/isNot';
import {
  snakeCase,
  camelCase,
} from 'lodash';

veeConfigure({ useConstraintAttrs: false });

export const initValidation = (
  {
    productName,
    constants,
    isLeadgen,
  }) => {
  const globalRules = require.context('./rules/common', true, /\.js$/);
  const productRules = require.context('./rules/products', true, /\.js$/);
  const sharedRules = require.context('./rules/shared', true, /\.js$/);

  const rules = {};

  const processFile = (resolve, productName) => filePath => {
    const pathParts = filePath.split('/');
    const productFolderName = pathParts[1];

    const isCoreRulesOmitted = isLeadgen && productFolderName === 'core';
    const isLgRulesOmitted = !isLeadgen && productFolderName === 'lg';

    /**
     * register only product specific rules for {@link productRules}
     */
    if (productName && productFolderName !== productName) {
      return;
    }

    /**
     * register only shared specific rules (core/lg) for {@link sharedRules}
     */

    if (isCoreRulesOmitted || isLgRulesOmitted) {
      return;
    }

    const name = pathParts[pathParts.length - 1].replace('.js', '');

    if (!rules[camelCase(name)]) rules[camelCase(name)] = resolve(filePath);
  };

  // Add constants to custom validation rules
  // It allow to use constants in validation rules by 'this'
  const extendValidationRule = function () {
    this.constants = constants;
    if (typeof this.message === 'function') {
      this.message = this.message.bind(this);
    }
  };

  productRules.keys().forEach(processFile(productRules, productName));
  globalRules.keys().forEach(processFile(globalRules));
  sharedRules.keys().forEach(processFile(sharedRules));

  Object.keys(rules).forEach(ruleName => {
    extendValidationRule.call(rules[ruleName].default, ruleName);

    veeExtend(camelCase(ruleName), rules[ruleName].default);
    veeExtend(snakeCase(ruleName), rules[ruleName].default);
  });

  const initBasicRules = function (ruleNames) {
    ruleNames.forEach(ruleName => veeExtend(camelCase(ruleName), { ...veeRules[ruleName], message: `${en.messages[snakeCase(ruleName)]}.` }));
  };

  initBasicRules([
    'alpha',
    'alpha_num',
    'alpha_spaces',
    'between',
    'confirmed',
    'digits',
    'integer',
    'is',
    'length',
    'max',
    'min',
    'max_value',
    'min_value',
    'numeric',
    'regex',
    'required',
    'size',
  ]);

  // TODO HOME
  if (productName === 'home') {
    veeExtend('claimTypeRequired', {
      ...veeRules.required,
      message: 'Please select the claim type.',
    });
    veeExtend('noClaimsYears', {
      ...veeRules.required,
      message: 'Please select no claims years.',
    });
    veeExtend('voluntaryExcess', {
      ...veeRules.required,
      message: 'Please select an excess amount.',
    });
    veeExtend('propertySpecificItems', {
      ...veeRules.required,
      message: 'Please select an item type.',
    });
  }

  // TODO GLOBAL
  veeExtend('listOptionRequired', {
    ...veeRules.required,
    message: 'Please select an option from this list.',
  });
  veeExtend('maritalStatus', {
    ...isNot,
    message: 'Please confirm your relationship status.',
  });
};
